var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { TaggingTool } from './tagging-tool.enum';
import { EventName, Events } from '../../utils/events';
import { RegionOfInterestProvider } from './region-of-interest';
import { CanvasProvider } from './canvas';
import { DatasetProvider } from '../dataset';
var ActiveToolProvider = /** @class */ (function () {
    function ActiveToolProvider(events, roiProvider, datasetProvider, canvasProvider) {
        var _this = this;
        this.events = events;
        this.roiProvider = roiProvider;
        this.datasetProvider = datasetProvider;
        this.canvasProvider = canvasProvider;
        this.activeTool = null;
        this.previousActiveTool = null;
        this.toolMenu = null;
        this.onCanvasPolygonRemoved = function () {
            _this.activatePenToolAfterSubtraction();
        };
        // TODO: refactor this when history management will be moved out of canvas provider
        this.events.subscribe(EventName.CanvasPolygonRemoved, this.onCanvasPolygonRemoved);
    }
    ActiveToolProvider.prototype.setActiveTool = function (tool) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (tool === this.activeTool) {
                            return [2 /*return*/];
                        }
                        if (this.activeTool !== null && Number.isInteger(this.activeTool)) {
                            this.previousActiveTool = this.activeTool;
                        }
                        if (tool == TaggingTool.Brush ||
                            tool == TaggingTool.Pen ||
                            tool == TaggingTool.Addition ||
                            tool == TaggingTool.Subtraction) {
                            this.latestDrawTool = tool;
                        }
                        if (!(this.activeTool === TaggingTool.RegionOfInterest && this.canvasProvider.hasUnsavedChangesInROI)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.roiProvider.confirmUnsavedChangesAndRetrain(this.datasetProvider.getCurrentDatasetIdentifier())];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.toolMenu && tool) {
                            this.toolMenu.show({ taggingTool: tool });
                        }
                        this.activeTool = tool;
                        return [2 /*return*/];
                }
            });
        });
    };
    ActiveToolProvider.prototype.activatePenToolAfterSubtraction = function () {
        if (this.getActiveTool() === TaggingTool.Subtraction && !this.canvasProvider.canSubtractPolygons()) {
            this.setActiveTool(TaggingTool.Pen);
        }
        if (this.latestDrawTool === TaggingTool.Subtraction && !this.canvasProvider.canSubtractPolygons()) {
            this.latestDrawTool = TaggingTool.Pen;
        }
    };
    ActiveToolProvider.prototype.getActiveTool = function () {
        return this.activeTool;
    };
    ActiveToolProvider.prototype.getPreviousActiveTool = function () {
        return this.previousActiveTool;
    };
    ActiveToolProvider.prototype.rollbackToPreviousActiveTool = function () {
        this.setActiveTool(this.getPreviousActiveTool());
    };
    ActiveToolProvider.prototype.useActiveDrawTool = function () {
        this.setActiveTool(this.getActiveDrawTool());
    };
    ActiveToolProvider.prototype.getActiveDrawTool = function () {
        if (this.activeTool == TaggingTool.Brush ||
            this.activeTool == TaggingTool.Pen ||
            this.activeTool == TaggingTool.Addition ||
            this.activeTool == TaggingTool.Subtraction ||
            this.activeTool == TaggingTool.BoundingBox) {
            return this.activeTool;
        }
        else if (this.latestDrawTool) {
            return this.latestDrawTool;
        }
        else {
            return TaggingTool.Pen;
        }
    };
    ActiveToolProvider.prototype.linkToolMenu = function (toolMenu) {
        this.toolMenu = toolMenu;
    };
    ActiveToolProvider.prototype.lock = function () {
        if (this.activeTool) {
            this.setActiveTool(null);
        }
    };
    ActiveToolProvider.prototype.unlock = function () {
        if (this.previousActiveTool && !this.activeTool) {
            this.setActiveTool(this.previousActiveTool);
        }
    };
    ActiveToolProvider.prototype.clearPreviousActiveTool = function () {
        if (this.previousActiveTool) {
            this.previousActiveTool = null;
        }
    };
    ActiveToolProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [Events,
            RegionOfInterestProvider,
            DatasetProvider,
            CanvasProvider])
    ], ActiveToolProvider);
    return ActiveToolProvider;
}());
export { ActiveToolProvider };
//# sourceMappingURL=active-tool.js.map


// WEBPACK FOOTER //
// ./src/providers/workspace/active-tool.ts.pre-build-optimizer.js